var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoints = function SvgPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6M11 11h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM1 1h6v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"
  })));
};
export default SvgPoints;